/**
 * The one neutral placeholder the listing content panel, its history modal
 * and the product header all fall back to when a stored image URL is
 * missing (specs/product/listing-content-panel, AUT-231). A single
 * exported constant so the three cannot drift apart.
 *
 * Deliberately not `resolveProductImage` -- that helper's fallback is a
 * real product photo (`cetaphilMoisturizer`), which this spec's images are
 * not allowed to substitute (`components/product.md § Real images on this
 * screen, and the fence around it`).
 */
export const PRODUCT_IMAGE_PLACEHOLDER = '/placeholder.svg';
